import type React from "react";

const ProfilePage: React.FC = () => {
	return (
		<div className="space-y-6">
			<h1 className="text-3xl font-bold">プロフィール</h1>
			<div className="bg-white p-6 rounded-lg shadow">
				<h2 className="text-xl font-semibold mb-4">基本情報</h2>
				{/* ユーザー情報を表示するコンポーネントをここに配置 */}
			</div>
			<div className="bg-white p-6 rounded-lg shadow">
				<h2 className="text-xl font-semibold mb-4">獲得バッジ</h2>
				{/* バッジ一覧を表示するコンポーネントをここに配置 */}
			</div>
			<div className="bg-white p-6 rounded-lg shadow">
				<h2 className="text-xl font-semibold mb-4">目標進捗状況</h2>
				{/* 目標進捗を表示するコンポーネントをここに配置 */}
			</div>
		</div>
	);
};

export default ProfilePage;
